const projects = [
  {
    image: 'images/pk.png',
    gif: 'videos/pk.gif',
    github: 'https://github.com/AndresHense/guess-pokemon-challenge',
    deploy: 'https://precious-tulumba-59ac2b.netlify.app/',
    tecnologies: ['React', 'Chakra UI', 'Typescript'],
    title: 'Guess the Pokemon',
  },
  {
    image: 'images/meli.png',
    gif: 'images/meli.png',
    github: 'https://github.com/AndresHense/mercadolibre-details-challenge',
    deploy: 'https://mercadolibre-details-clone.vercel.app/',
    tecnologies: ['React', 'Chakra UI', 'Typescript'],
    title: 'MeLi Product Page Clone',
  },
  {
    image: 'images/aerolab.png',
    gif: 'images/aerolab.png',
    github: 'https://github.com/AndresHense/aerolab-challenge',
    deploy: 'https://aerolab-challenge-opal.vercel.app/',
    tecnologies: ['React', 'Chakra UI', 'Typescript'],
    title: 'Aerolab E-Commerce challenge',
  },
  {
    image: 'images/huddle-landing-curve.png',
    gif: 'images/huddle-landing-curve.png',
    github: 'https://github.com/AndresHense/huddle-landing-page-curved',
    deploy: 'https://huddle-landing-page-curved-murex.vercel.app/',
    tecnologies: ['React', 'Chakra UI', 'Typescript', 'Framer Motion'],
    title: 'Huddle landing page curves',
  },
  {
    image: 'images/advice.png',
    gif: 'videos/advice.gif',
    github: 'https://github.com/AndresHense/advice-generator-app',
    deploy: 'https://tiny-brioche-ac66f4.netlify.app/',
    tecnologies: ['React', 'Chakra UI'],
    title: 'Random Advice Generator',
  },
  {
    image: 'images/landing.png',
    gif: 'images/landing.png',
    github: 'https://github.com/AndresHense/intro-section-with-dropdown-nav',
    deploy: 'https://kaleidoscopic-travesseiro-9833ff.netlify.app/',
    tecnologies: ['React', 'Chakra UI'],
    title: 'Landing Page',
  },
  {
    image: 'images/rating.png',
    gif: 'videos/rating.gif',
    github:
      'https://github.com/AndresHense/frontendmentor-interactive-rating-component',
    deploy: 'https://ornate-douhua-1799ea.netlify.app/',
    tecnologies: ['React', 'Chakra UI'],
    title: 'Rating Component',
  },
  {
    image: 'images/clipboard.png',
    gif: 'images/clipboard.png',
    github: 'https://github.com/AndresHense/clipboard-landing-page',
    deploy: 'https://lucky-gecko-53303d.netlify.app/',
    tecnologies: ['React', 'Chakra UI'],
    title: 'Clipboard Landing Page',
  },
  {
    image: 'images/tracking.png',
    gif: 'images/tracking.png',
    github: 'https://github.com/AndresHense/tracking-landing-page',
    deploy: 'https://tracking-landing-page.vercel.app/',
    tecnologies: ['React', 'Chakra UI'],
    title: 'Project Tracking Landing Page',
  },
  {
    image: 'images/sunny.png',
    gif: 'images/sunny.png',
    github: 'https://github.com/AndresHense/sunnyside-landing-page',
    deploy:
      'https://sunnyside-landing-page-f9i1oy2oz-andreshense-gmailcom.vercel.app/',
    tecnologies: ['React', 'Chakra UI', 'Typescript'],
    title: 'Sunnyside Landing Page',
  },
  {
    image: 'images/chart-component.png',
    gif: 'images/chart-component.png',
    github: 'https://github.com/AndresHense/expenses-chart-component',
    deploy: 'https://expenses-chart-component-pi.vercel.app/',
    tecnologies: ['React', 'Material UI', 'Typescript'],
    title: 'Chart Component',
  },
];

export default projects;
